/*
 * Cart PAGE Cart / Offers tabs.
 *
 * Mirrors the cart drawer's cart-drawer-tabs.js behaviour on the full /cart
 * page: switches between the normal cart view and an "Offers" view, and fills
 * the offer copy from the live <cart-progress-bar> element that
 * cart-summary.liquid already renders on the page (shipping_bar: true).
 */
(function () {
  function q(sel, root) {
    return (root || document).querySelector(sel);
  }
  function qa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function updateOffers(wrap) {
    if (!wrap) return;
    var bar = q('cart-progress-bar');
    var shipCard = q('[data-offer="shipping"]', wrap);
    var shipText = q('[data-offer-shipping-text]', wrap);
    var giftCard = q('[data-offer="gift"]', wrap);
    var giftText = q('[data-offer-gift-text]', wrap);
    var emptyMsg = q('[data-offers-empty]', wrap);
    var visible = 0;

    if (bar && typeof bar.getFormattedPrice === 'function') {
      if (shipCard && shipText) {
        var shipRemain = bar.shippingThreshold - bar.qualifyingSubtotal;
        if (shipRemain <= 0) {
          shipText.textContent = "You've unlocked free shipping on this order!";
        } else {
          shipText.textContent = 'Add ' + bar.getFormattedPrice(shipRemain) + ' more to get free shipping on this order';
        }
        visible += 1;
      }

      if (giftCard && giftText) {
        if (bar.giftAvailable) {
          giftCard.hidden = false;
          var label = (bar.giftLabel || 'free gift').toLowerCase();
          var giftRemain = bar.giftThreshold - bar.qualifyingSubtotal;
          if (giftRemain <= 0) {
            giftText.textContent = "You've unlocked your " + label + ' on this order!';
          } else {
            giftText.textContent = 'Add ' + bar.getFormattedPrice(giftRemain) + ' more to get your ' + label + ' on this order';
          }
          visible += 1;
        } else {
          giftCard.hidden = true;
        }
      }
    } else {
      if (shipCard) visible += 1;
      if (giftCard && !giftCard.hidden) visible += 1;
    }

    if (emptyMsg) emptyMsg.hidden = visible > 0;
  }

  function setTab(wrap, name) {
    if (!wrap) return;
    qa('[data-cart-page-tab]', wrap).forEach(function (t) {
      var active = t.dataset.cartPageTab === name;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    qa('[data-cart-panel]', wrap).forEach(function (p) {
      p.hidden = p.dataset.cartPanel !== name;
    });
    if (name === 'offers') updateOffers(wrap);
  }

  document.addEventListener('click', function (e) {
    var tab = e.target.closest ? e.target.closest('[data-cart-page-tab]') : null;
    if (!tab) return;
    var wrap = tab.closest('.main-cart-wrapper');
    setTab(wrap, tab.dataset.cartPageTab);
  });

  var updating = false;
  function refresh() {
    if (updating) return;
    var wrap = q('.main-cart-wrapper');
    if (!wrap) return;
    updating = true;
    updateOffers(wrap);
    requestAnimationFrame(function () {
      updating = false;
    });
  }

  function observe() {
    var host = q('#main-cart') || document.body;
    if (!host) return;
    var obs = new MutationObserver(function () {
      refresh();
    });
    obs.observe(host, { childList: true, subtree: true, characterData: true });
  }

  function init() {
    var wrap = q('.main-cart-wrapper');
    if (wrap) setTab(wrap, 'cart');
    refresh();
    observe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/*
 * Keep the Gorgias live-chat launcher (z-index ~2147483636, far above the cart)
 * from floating over the /cart page. This script only loads on the cart page,
 * so the chat is kept hidden the whole time the shopper is here -- nothing
 * covers the cart or its Checkout button, matching the cart drawer's rule.
 * Gorgias mounts asynchronously and re-shows itself, so we re-hide it on every
 * relevant DOM/style change (debounced). The "only touch if currently visible"
 * check keeps this from looping on our own writes.
 */
(function () {
  function gorgiasEls() {
    var els = [];
    var container = document.getElementById('gorgias-chat-container');
    if (container) els.push(container);
    document.querySelectorAll('[class*="gorgias-chat-key"]').forEach(function (el) {
      els.push(el);
    });
    return els;
  }

  function hideChat() {
    gorgiasEls().forEach(function (el) {
      if (getComputedStyle(el).display !== 'none') {
        el.style.setProperty('display', 'none', 'important');
      }
    });
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      hideChat();
    });
  }

  function start() {
    hideChat();
    if (document.body) {
      new MutationObserver(schedule).observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class']
      });
    }
    // Safety net for the async chat load in case a mutation is missed.
    var n = 0;
    var iv = setInterval(function () {
      hideChat();
      if (++n >= 20) clearInterval(iv);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();